import { Dispatch, SetStateAction } from 'react';
import MyModal from '../../../../components/Modal';
import { MappedVehicleType } from '../types';

interface DeleteModal {
  deleteModalShow: boolean;
  vehicleBeingDeleted: MappedVehicleType;
  setDeleteModalShow: Dispatch<SetStateAction<boolean>>;
  deleteVehicle: () => void;
}

export default function DeleteModal({
  deleteModalShow,
  vehicleBeingDeleted,
  setDeleteModalShow,
  deleteVehicle,
}: DeleteModal) {
  return (
    <MyModal
      show={deleteModalShow}
      title={`Remover veículo ${vehicleBeingDeleted.vehicleCode}`}
      modalBody={(
        <>Tem certeza que deseja remover o veículo {vehicleBeingDeleted.vehicleCode}?</>
      )}
      closeButtonLabel="Fechar"
      onClose={() => setDeleteModalShow(false)}
      actionButtonLabel="Remover"
      onAction={() => deleteVehicle()}
      type="deleteAction"
    />
  );
}
